var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('iframe',{staticClass:"frame",style:({ height: _vm.height }),attrs:{"scrolling":"no","srcdoc":_vm.html},on:{"load":_vm.onLoadFrame}})])}
var staticRenderFns = []

export { render, staticRenderFns }